class ImperiaPerformancePdp extends HTMLElement {
  connectedCallback() {
    this.variantSelect = this.querySelector('[data-performance-variant-select]');
    this.variantSelect?.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.variantSelect?.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const option = event.currentTarget.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    const variantId = this.querySelector('[ref="variantId"]');
    const price = this.querySelector('[data-performance-price]');
    const priceAmount = this.querySelector('[data-performance-price-amount]');
    const compare = this.querySelector('[data-performance-compare]');
    const promotions = this.querySelectorAll('[data-performance-promotion]');
    const discount = this.querySelector('[data-performance-discount]');
    const savings = this.querySelector('[data-performance-savings]');
    const availability = this.querySelector('[data-performance-availability]');
    const button = this.querySelector('[ref="addToCartButton"]');
    const buttonText = button?.querySelector('.add-to-cart-text__content');

    if (variantId && option?.value) variantId.value = option.value;
    if (priceAmount && option?.dataset.price) {
      priceAmount.textContent = option.dataset.price;
    } else if (price && option?.dataset.price) {
      price.textContent = option.dataset.price;
    }
    if (compare) {
      compare.textContent = option?.dataset.compare || '';
      compare.hidden = !option?.dataset.compare;
    }
    promotions.forEach((promotion) => { promotion.hidden = !option?.dataset.discount; });
    if (discount) discount.textContent = option?.dataset.discount ? `${option.dataset.discount}% OFF` : '';
    if (savings) savings.textContent = option?.dataset.savings || '';
    if (availability) availability.textContent = available ? 'DISPONIBLE ONLINE' : 'AGOTADO';
    if (button) button.disabled = !available;
    if (buttonText) buttonText.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
  };

}

if (!customElements.get('imperia-performance-pdp')) {
  customElements.define('imperia-performance-pdp', ImperiaPerformancePdp);
}
